module.exports = __webpack_public_path__ + "img/usa.fa161ca1.svg";